import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';
import UserAccountMenu from './UserAccountMenu';


const Sidebar = ({ isCollapsed = false, onToggleCollapse, user, onLogout }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isMobileOpen, setIsMobileOpen] = useState(false);

  const navigationItems = [
    {
      label: 'Projects',
      path: '/project-dashboard',
      icon: 'FolderKanban',
      description: 'Manage your applications'
    },
    {
      label: 'Builder',
      path: '/visual-builder',
      icon: 'Layout',
      description: 'Create and design'
    },
    {
      label: 'Templates',
      path: '/template-marketplace',
      icon: 'Layers',
      description: 'Browse templates'
    },
    {
      label: 'Assets',
      path: '/asset-manager',
      icon: 'Image',
      description: 'Manage media files'
    }
  ];

  const handleNavigation = (path) => {
    navigate(path);
    setIsMobileOpen(false);
  };

  const isActive = (path) => {
    return location?.pathname === path;
  };

  return (
    <>
      <button
        onClick={() => setIsMobileOpen(!isMobileOpen)}
        className="fixed top-4 left-4 z-50 lg:hidden bg-card text-foreground p-2 rounded-lg shadow-md hover:shadow-lg transition-all duration-250"
        aria-label="Toggle mobile menu"
      >
        <Icon name={isMobileOpen ? 'X' : 'Menu'} size={24} />
      </button>
      <div
        className={`fixed lg:relative top-0 left-0 h-full bg-card border-r border-border transition-all duration-250 z-40 lg:z-0 flex flex-col ${
          isCollapsed ? 'w-20' : 'w-60'
        } ${isMobileOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}`}
      >
        <div className={`sidebar ${isCollapsed ? 'collapsed' : ''} flex-1 flex flex-col`}>
          <div className="sidebar-header">
            <div className="sidebar-logo">
              {isCollapsed ? 'AC' : 'AC'}
            </div>
            {!isCollapsed && (
              <span className="ml-3 font-heading font-semibold text-lg text-foreground">
                DKS Creator
              </span>
            )}
          </div>

          <nav className="flex-1 px-4 py-6 space-y-2">
            {navigationItems?.map((item) => {
              const active = isActive(item?.path);
              return (
                <button
                  key={item?.path}
                  onClick={() => handleNavigation(item?.path)}
                  className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg transition-all duration-250 group ${
                    active
                      ? 'bg-primary text-primary-foreground shadow-sm'
                      : 'text-muted-foreground hover:bg-muted hover:text-foreground'
                  }`}
                  title={isCollapsed ? item?.label : ''}
                >
                  <Icon
                    name={item?.icon}
                    size={20}
                    className={`flex-shrink-0 ${
                      active ? 'text-primary-foreground' : 'text-current'
                    }`}
                  />
                  {!isCollapsed && (
                    <div className="flex-1 text-left">
                      <div className={`caption font-medium ${active ? 'font-semibold' : ''}`}>
                        {item?.label}
                      </div>
                      {!active && (
                        <div className="text-xs text-muted-foreground mt-0.5">
                          {item?.description}
                        </div>
                      )}
                    </div>
                  )}
                </button>
              );
            })}
          </nav>

          {onToggleCollapse && (
            <div className="hidden lg:block px-4 py-4 border-t border-border">
              <button
                type="button"
                onClick={(e) => {
                  e?.preventDefault();
                  e?.stopPropagation();
                  onToggleCollapse();
                }}
                className="w-full flex items-center justify-center p-2 rounded-lg text-muted-foreground hover:bg-muted hover:text-foreground transition-all duration-250"
                aria-label={isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
              >
                <Icon name={isCollapsed ? 'ChevronRight' : 'ChevronLeft'} size={20} />
              </button>
            </div>
          )}
          
          {!isCollapsed && user && (
            <UserAccountMenu user={user} onLogout={onLogout} />
          )}
        </div>
      </div>
      {isMobileOpen && (
        <div
          className="fixed inset-0 bg-background z-30 lg:hidden"
          onClick={() => setIsMobileOpen(false)}
          aria-hidden="true"
        />
      )}
    </>
  );
};

export default Sidebar;